import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getToken } from '../../utils/token';

export const loanApi = createApi({
  reducerPath: 'loanApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL+"/api",
    prepareHeaders: (headers) => {
      const token = getToken();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getLoan: builder.mutation({
      query: ({ pageIndex, pageSize, sorting, columnFilters, globalFilter,data }) => ({
        url: '/Getloan',
        method: 'POST',
        body: {
          data,
          pageIndex,
          pageSize,
          sorting,
          filters: columnFilters,
          globalFilter,
        },
      }),
    }),
  }),
});

export const { useGetLoanMutation } = loanApi;
